import type { TOC } from '@ember/component/template-only';
import type { EmberChangeset } from 'ember-changeset';
import LabeledTextArea from 'ui-kit/components/changeset/labeled-text-area';

interface Signature {
  Args: {
    changeset: EmberChangeset;
  };
}
const LifestyleTextareaComponent: TOC<Signature> = <template>
  <LabeledTextArea
    @labelName='Hygiène de vie'
    @propertyName='lifestyle'
    @changeset={{@changeset}}
  />
</template>;

export default LifestyleTextareaComponent;
